export default "__VITE_ASSET__yub0i_Kd__"